
$('.scroll').on("click", function(e) {

	e.preventDefault();

	var dest = $(this).attr("href");

	$("html, body").animate({

		'scrollTop':   $(dest).offset().top

	}, 1000);

});

function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

// $('#applicationForm').submit(function(e){
// 	e.preventDefault();
// 	swal('success', "Success", 'success');
// });